"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "mereto-di-tomba": {
    "36bd940d": [{
      "hkey": "5d04de7d",
      "slug": "mereto-di-tomba",
      "name": "Mereto di Tomba",
      "primary": true,
      "skipSearch": false
    }],
    "castelliere": [{
      "hkey": "5d04de7d",
      "slug": "mereto-di-tomba",
      "name": "Mereto di Tomba",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1d23d798": [{
      "hkey": "5d04de7d",
      "slug": "mereto-di-tomba",
      "name": "Mereto di Tomba",
      "primary": true,
      "skipSearch": false
    }],
    "savalons": [{
      "hkey": "5d04de7d",
      "slug": "mereto-di-tomba",
      "name": "Mereto di Tomba",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "667ea92c": [{
      "hkey": "afb659d7",
      "slug": "tomba",
      "name": "Tomba",
      "primary": true,
      "skipSearch": false
    }],
    "tomba-di-mereto": [{
      "hkey": "afb659d7",
      "slug": "tomba",
      "name": "Tomba",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;